import { render } from "./FAQQuestionDetail.vue?vue&type=template&id=1fb8f574&scoped=true"
import script from "./FAQQuestionDetail.vue?vue&type=script&lang=js"
export * from "./FAQQuestionDetail.vue?vue&type=script&lang=js"

import "./FAQQuestionDetail.vue?vue&type=style&index=0&id=1fb8f574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb8f574"]])

export default __exports__